import { OnlineCare, OnlineCareQuick } from '@/models/onlineCare';
import {
  ICancelRequestParam,
  IRequest,
  IRequestListItem,
  IRequestResponse,
  IRequestSummary,
  IRequestViewItem,
  RequestKindTypes,
} from '@/models/request';
import { SecondOpinion } from '@/models/secondOpinion';
import api from '../api/api';
import { ApiRequest } from './';
import getApiResponse from '@/api/apiResponse';
import { AxiosResponse } from 'axios';
import { IResponseData, ResultDatas } from '@/models/common';

export const RequestService = {
  async getRequestList(options: Object) {
    const res: AxiosResponse<IResponseData<Array<IRequestListItem>>> = await api.post(ApiRequest.REQUEST_LIST, options);
    return getApiResponse<Array<IRequestListItem>>(res);
  },

  async getReqeustView(key: Number) {
    const params = {
      key,
    };
    const res: AxiosResponse<IResponseData<IRequestViewItem>> = await api.get(ApiRequest.REQUEST_VIEW, { params });
    return getApiResponse<IRequestViewItem>(res);
  },

  async getRequest(key: Number) {
    const params = {
      key,
    };
    const res: AxiosResponse<IResponseData<IRequest>> = await api.get(ApiRequest.GET_REQUEST, { params });
    return getApiResponse<IRequest>(res);
  },

  async getRequestResponse(key: Number) {
    const params = {
      key,
    };
    const res: AxiosResponse<IResponseData<IRequestResponse>> = await api.get(ApiRequest.GET_REQUEST_RESPONSE, {
      params,
    });
    return getApiResponse<IRequestResponse>(res);
  },

  async getRequsetSummary(requestKind: RequestKindTypes) {
    const params = {
      requestKind,
    };
    const res: AxiosResponse<IResponseData<IRequestSummary>> = await api.get(ApiRequest.GET_REQUEST_SUMMARY, {
      params,
    });
    return getApiResponse<IRequestSummary>(res);
  },

  async save(data: OnlineCare | SecondOpinion | OnlineCareQuick) {
    if (data instanceof OnlineCare) {
      const res: AxiosResponse<IResponseData<IRequest>> = await api.post(ApiRequest.SAVE, data);
      return getApiResponse<IRequest>(res);
    } else if (data instanceof OnlineCareQuick) {
      const res: AxiosResponse<IResponseData<IRequest>> = await api.post(ApiRequest.SAVE_QUICK, data);
      return getApiResponse<IRequest>(res);
    } else {
      const res: AxiosResponse<IResponseData<IRequest>> = await api.post(ApiRequest.SAVE_SECOND_OPINION, data);
      return getApiResponse<IRequest>(res);
    }
  },

  async cancelRequest(data: ICancelRequestParam) {
    const res: AxiosResponse<IResponseData<string>> = await api.post(ApiRequest.CANCEL_REQUEST, data);
    return getApiResponse<string>(res) === ResultDatas.SUCCESS;
  },
};
export default RequestService;
